import(/* webpackMode: "eager", webpackExports: ["DownloadCard"] */ "/app/src/pages/download/ui/download-card.tsx");
